import React from 'react';

const ParticipantsAudioVolumeContext = React.createContext({});

export default ParticipantsAudioVolumeContext;
